var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error has-feedback': _vm.invalid
    }
  }, [(_vm.label) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.slotId
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    on: {
      "input": _vm.inputHandler
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [(_vm.invalid) ? [_vm._v(_vm._s(_vm.errorMessage))] : _vm._e()], 2)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-de485ad0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de485ad0","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./application/components/form/group.vue
// module id = 279
// module chunks = 3